<template>
    <b-row class="animated fadeIn" v-if="ready">
        <b-col cols="12" md="6">
            <b-card>
                <InputField name="name" :label="this.$t('name')" v-model="model.username" @error="fieldError"
                    :disabled="true" :rules="{ required: true, length: { min: 2 } }" />

                <b-form-group :label="this.$t('role')">
                    <v-select :options="roles" v-model="model.roles" multiple label="name" :disabled="!canManipulate" />
                </b-form-group>



                <b-form-group v-if="canManipulate">
                    <button class="btn btn-success" @click="save">{{ $t('save') }}</button>
                    <button class="btn btn-danger ml-2" @click="remove">{{ $t('delete') }}</button>

                </b-form-group>
            </b-card>
        </b-col>
        <b-col cols="12" md="6" v-if="canManipulate">
            <b-card>
                <b-row>
                    <b-col cols="12" class="mb-3">

                        <button class="btn btn-success ml-2" @click="generateNewSecret"
                            :disabled="model.secrets >= 5">{{ $t('generateNewSecret') }}</button>

                        <b-form-group class="ml-2 mt-1">
                            <b-form-checkbox v-model="forever" name="check-button" switch>
                                Forever <br /><small v-if="forever"> {{ $t('authTokenForeverDesc') }} </small>
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" v-for="secret in model.secrets" :key="secret.uuid">
                        <b-card-body>
                            <p>{{ secret.uuid }} <b-button variant="danger" size="sm" @click="revoke(secret)">{{
                                    $t('revoke') }}</b-button></p>
                            <small>
                                <b-form-group v-if="secret.secret" :label="$t('secret')" :label-cols="12"
                                    :description="$t('apiUserSecretDescription')" :horizontal="true">
                                    <b-input :value="secret.secret" disabled />
                                </b-form-group>
                                <p v-if="secret.auth_at">{{ $t('lastTimeUsed') }}: {{ $toUserTimeZone(secret.auth_at) }}
                                </p>
                                <p v-if="secret.forever"> {{ $t('authTokenForeverDesc') }} </p>
                            </small>
                        </b-card-body>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>

<style scoped>
.removeKey {
    cursor: pointer;
    margin-top: 5px;
}

.removeKey:hover {
    color: #ccc;
}
</style>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import VSelect from "vue-select"

export default {
    name: "Edit",
    components: {
        InputField: Input,
        SelectField: Select,
        VSelect
    },
    data: function () {
        return {
            ready: false,
            errors: [],
            model: {
                roles: [],
                secrets: []
            },
            forever: false
        }
    },

    computed: {
        roles() {
            return this.$store.getters.getRoles
        },

        modelFormated() {
            return {
                roles: this.model.roles.map(r => r.uuid)
            }
        },

        canManipulate() {
            return this.model.dependency === null
        }
    },
    methods: {

        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            this.$http.patch("/v1/user/api-user/" + this.$route.params.id, this.modelFormated).then((resp) => {

                this.$bvToast.toast(this.$t('success'), {
                    variant: 'success',
                    title: "Success"
                })
            }).catch(error => {
                if (error.response) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvModal.msgBoxOk(error.response.data.message)
                }
            })
        },

        generateNewSecret() {
            this.$bvModal.msgBoxOk(`${this.$t('areYouSure')}?`).then(resp => {
                if (!resp) return

                const popup = this.$loadingPopup()
                this.$http.post("/v1/user/api-user/secret/" + this.$route.params.id, {
                    forever: this.forever
                }).then((resp) => {
                    this.model.secrets.push(resp.data)
                }).catch(error => {
                    if (error.response) {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }

                        this.$bvModal.msgBoxOk(error.response.data.message)
                    }
                }).finally(() => {
                    popup.hide()
                })
            })
        },

        revoke(secret) {
            this.$bvModal.msgBoxOk(`${this.$t('areYouSure')}?`).then(resp => {
                if (!resp) return

                const popup = this.$loadingPopup()
                this.$http.delete("/v1/user/api-user/secret/" + secret.uuid).then(() => {
                    this.model.secrets = this.model.secrets.filter(s => {
                        return s.uuid != secret.uuid
                    })
                }).catch(error => {
                    if (error.response) {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }

                        this.$bvModal.msgBoxOk(error.response.data.message)
                    }
                }).finally(() => {
                    popup.hide()
                })
            })
        },

        remove(e) {
            e.preventDefault()

            this.$bvModal.msgBoxOk(`${this.$t('areYouSure')}?`).then(resp => {
                if (resp) {
                    this.$http.delete("/v1/user/api-user/" + this.$route.params.id).then((resp) => {
                        if (resp.status == 200) {
                            this.$router.push({ path: "/admin/users" })
                        }
                    }).catch(error => {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }

                        this.$bvModal.msgBoxOk(error.response.data.message)
                    })
                }
            })
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        addCustomField() {
            this.fields.push({
                key: "",
                value: ""
            })
        }
    },
    mounted() {
        this.$store.dispatch("fetchRoles").catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$bvModal.msgBoxOk(error.response.data.message)
        })

        this.$http.get("/v1/user/api-user/" + this.$route.params.id).then((resp) => {
            this.model = resp.data
            this.model.roles = this.model.roles.map(r => {
                return r.role
            })

            this.ready = true
        }).catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$bvModal.msgBoxOk(error.response.data.message)
        })
    }
}
</script>
